<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-tabs
                v-model="tab"
                color="secondary"
                :vertical="$vuetify.breakpoint.mdAndDown"
            >
                <v-tab
                    v-for="tab in tabs"
                    :key="tab.name['en']"
                    v-text="tab.name[lang]"
                    :to="tab.to"
                    class="
                        text-capitalize
                        d-flex
                        justify-start justify-sm-center
                        px-3
                    "
                ></v-tab>
            </v-tabs>
        </v-sheet>

        <v-tabs-items v-model="tab" class="mt-3">
            <router-view></router-view>
        </v-tabs-items>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "Stores",

    data() {
        return {
            tab: this.$route.path,
        };
    },

    computed: {
        lang() {
            return this.$route.params.lang;
        },

        tabs() {
            let tabs = [
                {
                    name: { el: "Καταστήματα", en: "stores", it: "Stores" },
                    to: `/${this.lang}/loyaltyPanel/stores/stores-tab`,
                },
            ]
                // {
                //     name: { el: "Οικονομικά Στοιχεία", en: "financial data", it: "Dati finanziari" },
                //     to: `/${this.lang}/loyaltyPanel/stores/financial-data`,
                // },
                // {
                //     name: { el: "", en: "Settings of Admin Panel", it: "" },
                //     to: `/${this.lang}/loyaltyPanel/stores/admin-panel-settings`
                // },
                // {
                //     name: { el: "", en: "Settings of Application", it: "" },
                //     to: `/${this.lang}/loyaltyPanel/stores/application-settings`
                // },
                if (this.getPermission('stores.financial_limits.read')) {
                    tabs.push({
                    name: {
                        el: "Ημερήσιο Όριο Συναλλαγών",
                        en: "Daily Transaction Limits",
                        it: "Limite di transazione giornaliera",
                    },
                    to: `/${this.lang}/loyaltyPanel/stores/daily-transaction-limits`,
                })

                }

                if (this.getPermission('stores.network_regions.read')) {
                    tabs.push({
                    name: {
                        el: "Περιφέρειες",
                        en: "Network Regions",
                        it: "Regioni",
                    },
                    to: `/${this.lang}/loyaltyPanel/stores/network-regions`,
                })
                }
                
            
            return tabs
        },
    },
    methods: {
        ...mapActions(["getPermission"])
    },
    watch: {
        $route: {
            immediate: true,
            handler(val) {
                if (val.path === `/${this.lang}/loyaltyPanel/stores`) {
                    this.$router.push(
                        `/${this.lang}/loyaltyPanel/stores/stores-tab?page=1`
                    );
                }
            },
        },
    },
};
</script>
